import { render, staticRenderFns } from "./product_model.vue?vue&type=template&id=ffa97a12&scoped=true"
import script from "./product_model.vue?vue&type=script&lang=js"
export * from "./product_model.vue?vue&type=script&lang=js"
import style0 from "./product_model.vue?vue&type=style&index=0&id=ffa97a12&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa97a12",
  null
  
)

export default component.exports